// extracted by mini-css-extract-plugin
export default {"popup":"UserPopUp_popup__l+EN3","logoutButton":"UserPopUp_logoutButton__riNhA","profileButton":"UserPopUp_profileButton__cioQ7"};